import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { useSelector } from 'react-redux';
import { getQueryKeys } from './queryKeys';

const getHouseAvailable = async ({ houseId, companyId }) => {
  return await request.get(
    `/HousingStock/company/${companyId}/houses/${houseId}/available`,
    null,
    'При загрузке доступа пользователя произошла ошибка'
  );
};

const useHouseAvailable = (houseId, options) => {
  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  return useQuery(
    getQueryKeys.houseAvailable(houseId, currentCompany?.id),
    () => getHouseAvailable({ houseId, companyId: currentCompany?.id }),
    {
      enabled: Boolean(houseId && currentCompany?.id),
      ...options,
    }
  );
};

export default useHouseAvailable;
